module.exports = __webpack_public_path__ + "static/media/v24.e2a189e5.mp4";